.container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 2rem;
	min-height: 200px;
}

.spinner {
	display: flex;
	gap: 0.5rem;
	align-items: center;
	justify-content: center;

	&.small {
		gap: 0.35rem;

		.dot {
			width: 8px;
			height: 8px;
		}
	}

	&.medium {
		gap: 0.5rem;

		.dot {
			width: 12px;
			height: 12px;
		}
	}

	&.large {
		gap: 0.65rem;

		.dot {
			width: 16px;
			height: 16px;
		}
	}
}

.dot {
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background: linear-gradient(135deg, var(--color-gray-600), var(--color-gray-800));
	animation: bounce 1.4s infinite ease-in-out both;

	&:nth-child(1) {
		animation-delay: -0.32s;
	}

	&:nth-child(2) {
		animation-delay: -0.16s;
	}
}

.message {
	margin-top: 1.5rem;
	font-size: 1.1rem;
	color: var(--color-text-secondary);
	font-weight: 500;
}

@keyframes bounce {
	0%,
	80%,
	100% {
		transform: scale(0);
		opacity: 0.5;
	}

	40% {
		transform: scale(1);
		opacity: 1;
	}
}

// Dark mode adjustments
@media (prefers-color-scheme: dark) {
	.dot {
		background: linear-gradient(135deg, var(--color-dark-300), var(--color-dark-100));
	}
}

// Mobile responsive
@media (max-width: 768px) {
	.container {
		padding: 1.5rem;
		min-height: 150px;
	}

	.message {
		font-size: 1rem;
	}
}
